import React from 'react';
import Input from '../elements/Input';

const PersonalIdentificationForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="ID Type"
      value={formData.idType || ''}
      onChange={e => setFormData({ ...formData, idType: e.target.value })}
      placeholder="e.g. Passport, Driver's License, Aadhar Card"
      error={formError.idType}
    />
    <Input
      label="ID Number"
      value={formData.idNumber || ''}
      onChange={e => setFormData({ ...formData, idNumber: e.target.value })}
      placeholder="e.g. M1234567, DL-0420198765432, 1234-5678-9012"
      error={formError.idNumber}
    />
    <Input
      label="Issue Date"
      type="date"
      value={formData.issueDate || ''}
      onChange={e => setFormData({ ...formData, issueDate: e.target.value })}
      error={formError.issueDate}
    />
    <Input
      label="Expiry Date"
      type="date"
      value={formData.expiryDate || ''}
      onChange={e => setFormData({ ...formData, expiryDate: e.target.value })}
      error={formError.expiryDate}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="Enter any additional notes or details"
      error={formError.notes}
    />
  </>
);

export default PersonalIdentificationForm;